import { fetchData } from '@issuu/request';
import { saveMixpanelSuperProps } from './mixpanel-util';
function isMixpanelInitialized(window) {
    return (window.mixpanel !== undefined &&
        typeof window.mixpanel.get_property === 'function' &&
        typeof window.mixpanel.register === 'function' &&
        typeof window.mixpanel.unregister === 'function');
}
class MixpanelTrackerWrapper {
    constructor(window) {
        this.window = window;
        this.queue = [];
        if (window.mixpanel && isMixpanelInitialized(window)) {
            this.setupMixpanelSuperProps(window.mixpanel);
        }
        else {
            const interval = setInterval(() => {
                if (window.mixpanel && isMixpanelInitialized(window)) {
                    clearInterval(interval);
                    this.queue.map(ev => {
                        this.mixpanelTracker(ev.event, ev.payload, ev.options);
                    });
                    this.queue = [];
                    this.setupMixpanelSuperProps(window.mixpanel);
                    this.tracker.initialized = true;
                }
            }, 100);
        }
        const tracker = (event, payload, options = {}) => {
            if (window.mixpanel && isMixpanelInitialized(window)) {
                this.mixpanelTracker(event, payload, options);
            }
            this.mixpanelTrackerQueue(event, payload, options);
        };
        const trackerPageView = (payload = {}) => {
            const { pathname } = window.location;
            const pageNameProp = { 'Page name': pathname };
            const eventName = 'View Page';
            if (window.mixpanel && isMixpanelInitialized(window)) {
                this.mixpanelTracker(eventName, { ...payload, ...pageNameProp });
            }
            this.mixpanelTrackerQueue(eventName, { ...payload, ...pageNameProp });
        };
        this.tracker = {
            track: tracker,
            trackPageView: trackerPageView,
            getDistinctId: () => window.mixpanel?.get_distinct_id?.(),
            reset: () => window.mixpanel?.reset?.(),
            initialized: !!window.mixpanel,
        };
    }
    getCookie(cookieName) {
        if (typeof this.window.document !== 'undefined') {
            const regexp = new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`);
            return this.window.document.cookie.replace(regexp, '$1');
        }
    }
    setupMixpanelSuperProps(mp) {
        saveMixpanelSuperProps(mp, this.window.location.search, ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'], 'utm_timestamp');
        saveMixpanelSuperProps(mp, this.window.location.search, ['embed_id', 'embed_domain', 'embed_context', 'embed_cta'], 'embed_timestamp');
        this.getUserInfo(mp);
    }
    getUserInfo(mp, options = {}) {
        const username = this.getCookie('site.model.username');
        const token = this.getCookie('site.model.token');
        const loggedIn = !!username && !!token;
        const user = mp.get_property('User ID');
        if ((loggedIn && user == undefined) || options.forcePlanCheck) {
            fetchData('/do/backend-tagmanager/user-info/')
                .then(response => {
                mp.register({
                    'Current Plan': response.user_plan,
                    'User ID': response.user_id,
                });
            })
                .catch(() => undefined);
        }
    }
    mixpanelTrackerQueue(event, payload, options = {}) {
        if (payload) {
            this.queue.push({
                event,
                payload,
                options,
            });
        }
        else {
            this.queue.push({ event, options });
        }
    }
    mixpanelTracker(event, payload, options = {}) {
        const mp = this.window.mixpanel;
        if (mp && !options.noPlanInfo && options.forcePlanCheck) {
            this.getUserInfo(mp, options);
        }
        mp?.track?.(event, payload || {});
    }
}
let mtw = undefined;
export function initMixpanel(windowGlobal) {
    const w = windowGlobal || window;
    if (!mtw || process.env.NODE_ENV === 'test') {
        mtw = new MixpanelTrackerWrapper(w).tracker;
    }
    return mtw;
}
